import { render, staticRenderFns } from "./PurchaseUpdateExpress.vue?vue&type=template&id=4492f150&"
import script from "./PurchaseUpdateExpress.vue?vue&type=script&lang=js&"
export * from "./PurchaseUpdateExpress.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseUpdateExpress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports